import { SegmentAudioInterface } from './../shared/model/segment-audio.interface';
import { FeatureEnum } from './../core/properties/feature.enum';
import { FeatureToggleService } from './../core/services/feature-toggle.service';
import { HttpClient } from '@angular/common/http';
import { DownloadResponse } from './../downloads/model/download-reponse.interface';
import { Injectable } from '@angular/core';
import { Cacheable } from 'ngx-cacheable';
import { Observable, of, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { RemoteApiService } from '../core';
import { Station } from './../core/models/station';
import { DownloadPlayout } from './models/download-playout.interface';
import { LinearPlayoutRequest } from './models/linear-playout-request.interface';
import { MetadataResponse } from './models/metadata-response.interface';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class LinearPlayoutService {
  private stopRequest: Subject<void> = new Subject<void>();

  constructor(private remoteApi: RemoteApiService, private featureToggleService: FeatureToggleService) { }

  getDataTableLinearPlayout(
    body: LinearPlayoutRequest
  ): Observable<MetadataResponse[]> {
    const { stationId, esId, startTime, endTime } = body;
    return this.remoteApi
      .getDownload<MetadataResponse[]>(`/metadata`, {
        stationId,
        esId,
        startTime,
        endTime,
        possibleTalk: true
      })
      .pipe(
        map((resp: MetadataResponse[]) => {
          return resp;
        })
      );
  }

  getAudioLinearPlayout(body: LinearPlayoutRequest): Observable<DownloadResponse> {
    const { stationId, esId, startTime, endTime } = body;
    return this.remoteApi
      .getDownload<DownloadResponse>(`/playout`, {
        stationId,
        esId,
        startTime,
        endTime
      })
      .pipe(
        map((resp: DownloadResponse) => {
          return resp;
        })
      );
  }

  downloadItem(entidade: DownloadPlayout): Promise<any> {
    return this.remoteApi
      .postDownload('/download', {
        stationId: entidade?.stationId,
        startDateTime: entidade.startDateTime,
        endDateTime: entidade.endDateTime,
        userId: entidade.userId,
        downloadType: entidade.downloadType,
        format: entidade.format,
        deliveryMethodType: entidade.deliveryMethodType
      })
      .toPromise();
  }

  cancelSegmentRequest() {
    this.stopRequest.next();
  }

  getSegmentsAudiosStation(body: LinearPlayoutRequest): Observable<SegmentAudioInterface | DownloadResponse> {
    const isAudioSegmentToggleEnabled = this.featureToggleService.isEnabled(
      FeatureEnum.isAudioSegmentToggleEnabled
    );
    if (isAudioSegmentToggleEnabled) {

      const { stationId, esId, startTime, endTime } = body;
      const parameters: any = {};

      return this.remoteApi.getStream<SegmentAudioInterface>(`/station/${stationId}/segments?start=${startTime}&duration=60`, parameters)
        .pipe(takeUntil(this.stopRequest));
    } else {
      return this.getAudioLinearPlayout(body);
    }
  }
}
